module.exports = __webpack_public_path__ + "assets/img/counter.webp?6af5936c2482de1155fa0ac21584e92f";